import _ from 'underscore';
import { AriaListener } from '@bingads-webui/aria-listener';
import { OneDSListener } from '@bingads-webui/oneds-listener';
import {
  getAriaConfig,
  PerformanceLogsFormatter,
  PerformanceLogsFilter,
} from '@bingads-webui-campaign/instrumentation';

export default function getPerfLogListeners(props) {
  const { ariaConfig: applicationAriaConfig = {}, serverContext = {} } = props || {};
  const isOneDSListenerEnabled = _.get(serverContext, ['DynamicPermissions', 'OneDSListener'], false);

  const currentEnv = document.domain;
  const ariaConfig = {
    ...getAriaConfig(currentEnv),
    ...applicationAriaConfig,
  };

  // init log formatters
  const performanceLogsFormatter = new PerformanceLogsFormatter();

  // init log filters
  const performanceLogsFilter = new PerformanceLogsFilter();

  let perfLogListener;
  if (isOneDSListenerEnabled) {
    perfLogListener = new OneDSListener({
      tenantToken: ariaConfig.token,
      batchSize: ariaConfig.batchSize,
      logTableNames: {
        resourcetiming: {
          name: 'resourcetiming',
        },
      },
      defaultLogCategory: 'resourcetiming',
      formatters: {
        performanceLogsFormatter,
      },
      filters: {
        performanceLogsFilter,
      },
    });

    perfLogListener.init();
  } else {
    perfLogListener = new AriaListener({
      tenantToken: ariaConfig.token,
      flushInterval: ariaConfig.flushInterval,
      batchSize: ariaConfig.batchSize,
      logTableNames: {
        resourcetiming: {
          name: 'resourcetiming',
        },
      },
      defaultLogCategory: 'resourcetiming',
      formatters: {
        performanceLogsFormatter,
      },
      filters: {
        performanceLogsFilter,
      },
    });

    perfLogListener.init();
    perfLogListener.registerForTeardown();
  }

  const listeners = {
    perfLogListener,
  };

  return listeners;
}
